var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"default":""}),_vm._v(" "),(_vm.isSandpit)?_c('span',{staticClass:"text-caption font-weight-thin ml-1"},[_vm._v(_vm._s(_vm.$t('admin-sandpit-item-name.sp')))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }